import React, {useState} from "react";
import {FormattedMessage, injectIntl, useIntl} from "react-intl";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {getFormData} from "../../components/manager/form";
import "../../style/custom/failure-purchase.scss";
import {Link} from "react-router-dom";
import ErrorMessage from "../../components/utils/error-message";
import Footer from "../../components/section/footer";
import StandardTerms from "../../components/standard-terms";
import PrivacyPolicy from "../../components/portal/privacy-policy";


function FinalFailure (props) {
  const {formatMessage} = useIntl();
  const data = getFormData();
  const {response} = data;
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);
  console.log("RESPONSE >>> ", response);

  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="failure-page-container">
        <div className="failure-landing">
          <div className="section-1">
            <Row className="vw-fs">
              <Col xs={12} md={12} className="vw-fs-section">
                <div className="failure-modal">
                  <div className="failure-modal-heading">
                    {"Something Went Wrong"}
                  </div>

                  <div className="failure-modal-body">
                    <div className="failure-purchase-details">
                      <h2>
                        <FormattedMessage id={"register.final.failure-message"} />
                      </h2>

                      <p>
                        {(() => {
                          if (response?.graphQLErrors) {
                            if (response.graphQLErrors.length > 0 && Array.isArray(response?.graphQLErrors)) {
                              return response.graphQLErrors.map((x) => {
                                if (typeof x === "string") {
                                  return ErrorMessage(x);
                                }
                                x = {
                                  message: x.message.includes("proper_email") ? <FormattedMessage id={"portal.details.invalidEmail"} /> : x.message,
                                };
                                return ErrorMessage(x.message);
                              });
                            }
                            return (<FormattedMessage id={"register.final.failure-message.error"} values={{message: response?.message}} />);
                          }
                          if (response?.message && typeof response?.message === "string") {
                            return response?.message;
                          }
                          return (<FormattedMessage id={"register.final.failure-message.error"} values={response} />);
                        })()}
                      </p>

                      <div className="failure-purchase-actions">
                        <Link to="/review" className="retrieve-confirm">
                          {formatMessage({id: "buttons.failure"})}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Footer setTerm={setTerm} setPolicy={setPolicy}/>
        </div>
      </div>
    </>
  );
}

export default injectIntl(FinalFailure);